import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/session`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    const exchangeSession = async () => {
      if (processed.current) {
        return;
      }
      processed.current = true;
      const fragment = new URLSearchParams(location.hash.replace("#", ""));
      const sessionId = fragment.get("session_id");
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const response = await axios.post(
          apiUrl,
          { session_id: sessionId },
          { withCredentials: true },
        );
        navigate("/dashboard", { replace: true, state: { user: response.data.user } });
      } catch (error) {
        toast.error("We couldn’t finish your Google sign-in. Please try again.");
        navigate("/login", { replace: true });
      }
    };
    exchangeSession();
  }, [location.hash, navigate]);

  return null;
}